import { DistributionPlansResponse } from 'services/api/responses/responseTypes';
import { usePricingContext } from 'services/contexts/PricingContext';
import {
  StyledCheckIcon,
  StyledList,
  StyledListItem,
  StyledTypography,
} from './styled';

type PropsType = {
  data: DistributionPlansResponse;
};

const DistributionFeaturesList = ({ data }: PropsType) => {
  const { isAnnualPaymentSelected } = usePricingContext();

  const { distroPlus, distroBasic } = data;
  const features = isAnnualPaymentSelected
    ? distroPlus.features
    : distroBasic.features;

  return (
    <StyledList data-testid="distro-features-list">
      {features.map((feature) => (
        <StyledListItem key={feature.name.replace(' ', '-')}>
          <StyledCheckIcon />
          <StyledTypography>{feature.name}</StyledTypography>
        </StyledListItem>
      ))}
    </StyledList>
  );
};

export default DistributionFeaturesList;
